import React from "react";

export default function YearLabel({ year }) {
  return (
    <div className="flex items-center justify-center w-full my-4">
      {/* Left Line */}
      <div className="w-1/12 md:w-1/4 h-px bg-gray-400"></div>

      {/* Year Title */}
      <div className="mx-4 text-2xl font-bold text-gray-200 tracking-wider">
        {year}
      </div>

      {/* Right Line */}
      <div className="w-1/12 md:w-1/4 h-px bg-gray-400"></div>
    </div>
  );
}
